import { useBlockProps } from '@wordpress/block-editor';

export default function Save({ attributes }) {
  const { slides, padding, colorbg, title, url, positiontitle, container } =
    attributes;
  const blockProps = useBlockProps.save({
    className: `catthree ${colorbg ? 'sectiongray' : ''} ${padding}`,
  });

  const [firstSlide, ...frontSlides] = slides;

  const Tag = title ? 'section' : 'div';

  return (
    <>
      {frontSlides && (
        <Tag {...blockProps}>
          <div className={container ? '' : 'container'}>
            {title && (
              <div class="row">
                <div className={`globaltitle ${positiontitle}`}>
                  <h2>{title}</h2>
                  {url && (
                    <a href={url} class="btn btn-square btn-mini btn-url">
                      Смотреть все изделия
                    </a>
                  )}
                </div>
              </div>
            )}
            <div class="row g-4">
              {firstSlide && (
                <div class="col-12 col-lg-4">
                  <a href={firstSlide.url} class="cattwo__item itembig">
                    <div class="cattwo__item-img">
                      <img
                        loading="lazy"
                        src={firstSlide.image.url}
                        alt={firstSlide.image.alt}
                        height={firstSlide.image.height}
                        width={firstSlide.image.width}
                      />
                    </div>
                    <div class="cattwo__item-title">
                      <h3>{firstSlide.title}</h3>
                    </div>
                  </a>
                </div>
              )}
              <div class="col-12 col-lg-8">
                <div class="row g-4">
                  {frontSlides.map((slide, index) => (
                    <div class="col-6 col-lg-4 col-xl-3">
                      <a href={slide.url} class="cattwo__item">
                        <div class="cattwo__item-img">
                          <img
                            loading="lazy"
                            src={slide.image.url}
                            alt={slide.image.alt}
                            height={slide.image.height}
                            width={slide.image.width}
                          />
                        </div>
                        <div class="cattwo__item-title">
                          <h3>{slide.title}</h3>
                        </div>
                      </a>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </Tag>
      )}
    </>
  );
}
